export type MedicalKeyword = {
  label: string;
  value: string | string[];
};

export type MedicalCategory = {
  label: string;
  value: string;
  keywords: MedicalKeyword[];
};

// https://metriport.slack.com/archives/C07MUUHVCAX/p1761079039996479
export const MEDICAL_CATEGORIES: MedicalCategory[] = [
  {
    label: "Cardiology",
    value: "cardiology",
    keywords: [
      { label: "Aort", value: "aort" },
      { label: "Athero", value: "athero" },
      { label: "Calcif", value: "calcif" },
      { label: "Aneurysm", value: "aneurysm" },
      { label: "Ecta", value: "ecta" },
      { label: "Dilat", value: "dilat" },
      { label: "Coronary", value: "coronary" },
      { label: "CHF, HF, heart failure", value: ["chf", "hf", "heart failure"] },
      { label: "CHB, SSS, PPM", value: ["chb", "sss", "ppm"] },
      { label: "angina", value: "angina" },
      { label: "afib, fibrillation", value: ["afib", "fibrillation"] },
      {
        label: "echo, LVEF, ejection fraction, RVSP, PASP",
        value: ["echo", "lvef", "ejection fraction", "rvsp", "pasp"],
      },
      {
        label: "peripheral vascular, peripheral arter",
        value: ["peripheral vascular", "peripheral arter"],
      },
    ],
  },
  {
    label: "Pulmonary",
    value: "pulmonary",
    keywords: [
      { label: "COPD", value: "copd" },
      { label: "Emphysema", value: "emphysema" },
      { label: "Bronch", value: "bronch" },
      { label: "Asthma", value: "asthma" },
      { label: "Bleb", value: "bleb" },
      { label: "Bulla", value: "bulla" },
    ],
  },
  {
    label: "Use disorders",
    value: "use-disorders",
    keywords: [
      { label: "Alcohol", value: "alcohol" },
      { label: "ETOH", value: "etoh" },
      { label: "substance", value: "substance" },
      { label: "abuse", value: "abuse" },
      { label: "dependence", value: "dependence" },
    ],
  },
  {
    label: "Psychiatry",
    value: "psychiatry",
    keywords: [
      { label: "MDD", value: "mdd" },
      { label: "depress", value: "depress" },
      { label: "bipolar", value: "bipolar" },
      { label: "schiz", value: "schiz" },
    ],
  },
  {
    label: "Eye",
    value: "eye",
    keywords: [
      { label: "Retinopathy, Retina", value: ["retinopathy", "retina"] },
      { label: "Macula", value: "macula" },
    ],
  },
  {
    label: "Imaging/Labs",
    value: "imaging-labs",
    keywords: [
      { label: "Nodule", value: "nodule" },
      { label: "A1c", value: "a1c" },
      { label: "BNP", value: "bnp" },
      { label: "GFR", value: "gfr" },
      { label: "PTH", value: "pth" },
      { label: "DEXA, T score", value: ["dexa", "t score"] },
      { label: "meningioma", value: "meningioma" },
      { label: "cirrhosis", value: "cirrhosis" },
      { label: "atrophy", value: "atrophy" },
      { label: "hepatitis", value: "hepatitis" },
    ],
  },
];
